import React from "react";
import { useState, useEffect, useContext } from "react";
import logo from "../img/logo-02.png";
import { Link, useNavigate } from "react-router-dom";
import Loading from "./Loading";
import supabase from "../Supa";
import { MyContext } from "../context";
/*
import { signInWithEmailAndPassword } from "firebase/auth";
import auth from "../firebase";
*/

function Login({setToken}) {

  const { Logins, updateLogins } = useContext(MyContext);

  let navigate = useNavigate()

  const [userList, setUserList] = useState([]);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [er, setEr] = useState({status:false, massage:""});

  useEffect(() => {
    /*  auth.onAuthStateChanged((userAuth) => {
      if (userAuth) {
        window.location.href = "/dashboard";
      }
    });
   */

    

    const session = sessionStorage.getItem('token')
    if(session){
      navigate('/home')
      }
  }, []);

  /*
  
     async function getUser(){
        try{


            const { data: { user } } = await supabase.auth.getUser()
            if(user != null){

            setUsers(user)
            setTicketBoolean(user.user_metadata.Ticket)
            updateuserId(user.id)
            setLoading(false)
           
            }else{
                
                setUsers({user_metadata:{Ticket:"null"}})
                
            }

       
          }catch(e){
            console.log(e.message)
        }
    }

  */

  let signedIn = async(e) => {
    e.preventDefault();

    try {
 
      const { data, error } = await supabase.auth.signInWithPassword({
          email: email,
          password: password,
        })
        
        if (error) throw error
        
        
        const ticket = data.user.user_metadata.Ticket
       // console.log(data.user.user_metadata.Ticket)
        if(ticket === "yes")
        {
          setToken(data)
          updateLogins("TicketSystem")
          sessionStorage.setItem('view',"TicketSystem")
          return  navigate("/home")
        }
        setToken(data)
        updateLogins("BatterySystem")
        sessionStorage.setItem('view',"BatterySystem")
        navigate("/home")
            
       }catch(error){
        //const ErrorMessage = [error]+ ""
        console.log(error)
        //alert(error)
        const ErrorMsg = JSON.stringify(error)
        const errorJsonString = ErrorMsg
        const parsedErrorObject = JSON.parse(errorJsonString);
        
        setEr({status:true, massage:parsedErrorObject.message})

       }

    /* 
    signInWithEmailAndPassword(auth, email, password)
      .then((userCredential) => {
        
        const user = userCredential.user;

        window.location.href = "/dashboard";
      })
      .catch((error) => {
        const errorCode = error.code;
        alert(errorCode);
      });*/
  };

  return (
    <>
      <div>
        <div className="Login-container">
          <div className="Login-left">
            <img
              src={logo}
              className="Login-animation a6"
              style={{ margin: "0 auto 10px", width: "150px" }}
              alt="Login"
            />
            {loading && <Loading />}
            <div className="Login-header">
              <h2 className="Login-animation a1">Welcome Back</h2>
              <p className="Login-animation a2">
                IG3N (Pty) Ltd is a manufacturing start-up that assembles
                LiFePO4 batteries and is currently the “Premier player”
                [assembler] in the Lithium Iron storage market in South Africa.{" "}
              </p>
            </div>
            <div className="Login-form">
              <input
                type="email"
                className="Login-form-field Login-animation a3"
                name=""
                placeholder="Email"
                onChange={(e) => {
                  setEmail(e.target.value);
                }}
              />
              <input
                type="password"
                className="Login-form-field Login-animation a4 "
                name=""
                placeholder="Password"
                style={{ marginTop: "10px" }}
                onChange={(e) => {
                  setPassword(e.target.value);
                }}
              />

                {er.status ? 
                <div class="alert alert-danger" role="alert" style={{marginTop:"20px"}}>
                 {er.massage}
                </div> : ""}
                


              <div className="Login-animation a5" style={{ margin: "20px" }}>
                <span style={{ fontSize: "12px" }}>
                {/*  <input
                    type="checkbox"
                    id="check"
                    className="Login-animation a5"
                    name=""
                  />
                   
                  <label
                    for="check"
                    style={{ paddingLeft: "10px", color: "#afafaf" }}
                  >
                    Remember my password
                  </label>{" "}*/}
                   {" "}
                  <Link to="/registration" className="">
                    Battery Registration{" "}
                  </Link>{" "}
                  |

                  {" "}
                  <Link to="/registration_ticket" className="">
                    Ticket Support Registration{" "}
                  </Link>{" "}
                  |{" "}
                  <Link to="/reset" className="">
                    Forgot Password?{" "}
                  </Link>
                </span>
              </div>
              <div style={{ textAlign: "end" }}>
                <button className="btn1 btn-default" onClick={signedIn}>
                  Login
                </button>
              </div>
            </div>
          </div>
          <div id="Loing-right"></div>
        </div>
      </div>
    </>
  );
}

export default Login;
